export default __webpack_public_path__ + "static/project_royal_mail-f41e207f5c8ddc6f7d0ac65e419e5a36.svg";